import FacebookIcon from "../../assets/icons/FacebookIcon";
import InstagramIcon from "../../assets/icons/InstagramIcon";
import LocationIcon from "../../assets/icons/LocationIcon";
import MessageIcon from "../../assets/icons/MessageIcon";
import TelegramIcon from "../../assets/icons/TelegramIcon";
import WhatsappIcon from "../../assets/icons/WhatsappIcon";
import LogoFooter from "../../assets/LogoFooter.png";

function Footer() {
  return (
    <footer className="hidden md:block bg-[#27251F] text-[#B7B8B9] py-8">
      <div className="container mx-auto md:px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Логотип и социальные сети */}
        <div className="space-y-7">
          {/* Можно раскомментировать и использовать логотип */}
          {/* <img src={LogoFooter} alt="VANIL" /> */}
          <a href="/" className="px-2 py-1.5 bg-pink-400 text-[#27251F] max-w-[93px] font-cinzel tracking-[0.4em] leading-none">
            VANIL
          </a>
          <div className="flex space-x-4">
            <a 
              href="https://www.facebook.com/p/vanil_kz_-100077410761253/?locale=pt_PT" 
              target="_blank"
              rel="noopener noreferrer"
              className="group hover:text-pink-300"
            >
              <FacebookIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
            </a>
            <a
              href="https://www.instagram.com/vanil_kz_/"
              target="_blank"
              rel="noopener noreferrer"
              className="group hover:text-pink-300"
            >
              <InstagramIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
            </a>
            <a href="/company-info#contacts" className="group hover:text-pink-300">
              <WhatsappIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
            </a>
            {/* <a href="#" className="group hover:text-pink-300">
              <TelegramIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
            </a> */}
          </div>
          <div>
            <a href="/company-info#stores" className="flex space-x-2 group hover:text-pink-300 ">
              <LocationIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
              <span>Найти магазин</span>
            </a>
            <a href="/company-info#contacts"  className="flex space-x-2 group hover:text-pink-300 mt-4">
              <MessageIcon className="text-[#B7B8B9] group-hover:text-pink-300" />
              <span>Написать сообщение</span>
            </a>
          </div>
          <p className="text-xs mt-4">Все права защищены.</p>
        </div>

        {/* Информация */}
        <div>
          <h3 className="mb-4">Информация</h3>
          <ul className="space-y-2 text-sm text-white/50">
            <li>
              <a href="/company-info#about" className="hover:text-pink-300">
                О компании
              </a>
            </li>
            <li>
              <a href="/company-info#stores" className="hover:text-pink-300">
                Магазины
              </a>
            </li>
            <li>
              <a href="/company-info#offer" className="hover:text-pink-300">
                Публичная оферта
              </a>
            </li>
            <li>
              <a href="/privacy-policy" className="hover:text-pink-300">
                Политика конфиденциальности
              </a>
            </li>
            <li>
              <a href="/company-info#contacts" className="hover:text-pink-300">
                Контакты
              </a>
            </li>
          </ul>
        </div>

        {/* Сервис */}
        <div>
          <h3 className="mb-4">Сервис</h3>
          <ul className="space-y-2 text-sm text-white/50">
            <li>
              <a href="/company-info#delivery" className="hover:text-pink-300">
                Доставка
              </a>
            </li>
            <li>
              <a href="/company-info#payment" className="hover:text-pink-300">
                Оплата
              </a>
            </li>
            <li>
              <a href="/refund" className="hover:text-pink-300">
                Возвраты и оплата
              </a>
            </li>
            <li>
              <a href="/company-info#bonus" className="hover:text-pink-300">
                Бонусный клуб
              </a>
            </li>
          </ul>
        </div>

        {/* Помощь */}
        <div>
          <h3 className="mb-4">Помощь</h3>
          <ul className="space-y-2 text-sm text-white/50">
            <li>
              <a href="/company-info#faq" className="hover:text-pink-300">
                Вопрос-ответ
              </a>
            </li>
            <li>
              <a href="/company-info#storage" className="hover:text-pink-300">
                Хранение и уход
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
